const AccountSearchType = 
{
    'EMAIL': '이메일',
    'NAME': '이름',
    'PHONE': '전화번호'
}

export default AccountSearchType